export const FONT = {
  w200: 'fontThin',
  w300: 'fontLight',
  w400: 'fontRegular',
  w500: 'fontMedium',
  w600: 'fontSemiBold',
  w700: 'fontBold',
  w800: 'fontExtraBold',
};
